<template>
    <div style="background-color: white;">
        <img src="http://jho2o2.oss-cn-beijing.aliyuncs.com/test/2NcmJ5te.jpg" width="100%" />
        <div style="text-align:center; margin: 5rem 0;">
            <van-field v-model="query.phone" type="number" label="手机号" placeholder="输入兑换手机号" class="input" />
            <van-button type="primary" size="normal" @click="simpleJobOrderDeclare" class="joinButton">参与活动</van-button>
        </div>
        <div style="width:90%;margin:0 auto;">
            注意事项：<br/>
            此界面输入手机号必须和积分兑换手机号一致，否则会影响结算数据
        </div>
    </div>
</template>

<script>
    import mainAPI from '@/api/main';
    import pvuvAPI from '@/api/pvuv';

    export default {
        data() {
            return {
                query: {
                    jobId: this.$route.query.jobId,
                    traderId: this.$route.query.traderId,
                    jobLinkUpPid: this.$route.query.pid,
                    phone: '',
                },
            }
        },
        methods: {
            simpleJobOrderDeclare() {
                if (!this.$myUtil.mobile(this.query.phone)) {
                    this.$toast("请输入正确的手机号");
                    return;
                }
                mainAPI.simpleJobOrderDeclare(this.query).then(() => {
                    window.location.href = 'http://dhjf.juzitg.com/dtshop/login.html?icode=2ffb9a62fdc96e74af7e687c92718a93';
                }).catch(() => {
                });
            },
        },
        created() {
        },
        mounted() {
        }
    }

</script>

<style lang="scss" scoped>

    .input {
        height: 5rem;
        font-size: 1.5rem;
        margin: 2rem 0;
    }

    .joinButton {
        width: 15rem;
        font-size: 1.5rem;
        font-weight: bold;
        color: #FFFFFF;
    }

</style>
